import {
  CreateContentTargetInput,
  ContentTargetAreaType,
  InputMaybe,
} from '@converge/graphql';

import { Grid } from '@mui/material';
import { ContentCreateForm } from './content.create.form';

import { ContentHeader } from './contents.header';

export interface IContentProps extends CreateContentTargetInput {
  title: string;
  hideHeader?: boolean;
  containerWidth?: number;
  testId?: string;
  targetArea?: InputMaybe<ContentTargetAreaType>;
  targetSubUuid?: string | null | undefined;
  targetSubName?: string | null | undefined;
  label?: string | null | undefined;
  labelMargin?: number;
  minHeight?: number;
  minHeightForTextFile?: number;
  content?: string;
}

export const ConvergeContents = ({
  title,
  content,
  hideHeader,
  targetName,
  targetType,
  targetUuid,
  containerWidth,
  testId,
  targetArea,
  targetSubUuid,
  targetSubName,
  label,
  labelMargin,
  minHeight,
  minHeightForTextFile,
}: IContentProps) => {
  return (
    <Grid item xs={12} md={containerWidth} data-testid={testId}>
      {!hideHeader && <ContentHeader title={title} />}
      <ContentCreateForm
        targetUuid={targetUuid}
        targetName={targetName}
        targetSubUuid={targetSubUuid}
        targetArea={targetArea}
        labelMargin={labelMargin}
        minHeight={minHeight}
        content={content}
        minHeightForTextFile={minHeightForTextFile}
        label={label}
      />
    </Grid>
  );
};
